var table_viewer_default = {
  "viewMode": "L0rMU",
  "editMode": "WsZhj",
  "container": "uau0o",
  "cell": "uFG2r"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
